const KEY = "gmscan_watchlist";

export const getWatchlist = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
};

const save = (list) => {
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new Event("gmscan:watchlist-changed"));
};

export const isWatched = (value) =>
  getWatchlist().some((i) => i.value.toLowerCase() === String(value).toLowerCase());

export const addToWatchlist = (item) => {
  const list = getWatchlist().filter((i) => i.value.toLowerCase() !== item.value.toLowerCase());
  list.unshift({ ...item, addedAt: new Date().toISOString() });
  save(list);
  return list;
};

export const removeFromWatchlist = (value) => {
  const list = getWatchlist().filter((i) => i.value.toLowerCase() !== String(value).toLowerCase());
  save(list);
  return list;
};

export const renameWatchItem = (value, label) => {
  const list = getWatchlist().map((i) =>
    i.value.toLowerCase() === String(value).toLowerCase() ? { ...i, label } : i
  );
  save(list);
  return list;
};

export const exportWatchlist = () => {
  const blob = new Blob([JSON.stringify(getWatchlist(), null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "gmscan-watchlist.json";
  a.click();
  URL.revokeObjectURL(url);
};

export const importWatchlist = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const items = JSON.parse(reader.result);
        if (!Array.isArray(items)) throw new Error("Invalid file");
        const merged = [...items, ...getWatchlist()];
        const seen = new Set();
        const deduped = merged.filter((i) => {
          const k = String(i.value).toLowerCase();
          if (seen.has(k) || !i.value) return false;
          seen.add(k);
          return true;
        });
        save(deduped);
        resolve(deduped);
      } catch (e) {
        reject(e);
      }
    };
    reader.readAsText(file);
  });

const RECENT_KEY = "gmscan_recent_searches";
export const getRecentSearches = () => {
  try {
    return JSON.parse(localStorage.getItem(RECENT_KEY) || "[]");
  } catch {
    return [];
  }
};
export const addRecentSearch = (entry) => {
  const list = [entry, ...getRecentSearches().filter((e) => e.value !== entry.value)].slice(0, 8);
  localStorage.setItem(RECENT_KEY, JSON.stringify(list));
};
